import { apiClient } from './client';
import { downloadPdfBlob } from '../utils/downloadPdf';
import {
  ProcessChart,
  ProcessChartAttachment,
  ProcessChartPayload,
} from '../types/processChart';

export async function fetchProcessCharts(
  keyword?: string,
  contractId?: number | null
): Promise<ProcessChart[]> {
  const params: Record<string, string | number> = {};
  if (keyword?.trim()) params.q = keyword.trim();
  if (contractId != null) params.contractId = contractId;
  const { data } = await apiClient.get<ProcessChart[]>('/process-charts', {
    params: Object.keys(params).length ? params : undefined,
  });
  return data;
}

export async function fetchProcessChart(processChartId: number): Promise<ProcessChart> {
  const { data } = await apiClient.get<ProcessChart>(`/process-charts/${processChartId}`);
  return data;
}

export async function createProcessChart(payload: ProcessChartPayload): Promise<ProcessChart> {
  const { data } = await apiClient.post<ProcessChart>('/process-charts', payload);
  return data;
}

export async function updateProcessChart(
  processChartId: number,
  payload: ProcessChartPayload
): Promise<ProcessChart> {
  const { data } = await apiClient.patch<ProcessChart>(
    `/process-charts/${processChartId}`,
    payload
  );
  return data;
}

export async function deleteProcessChart(processChartId: number): Promise<void> {
  await apiClient.delete(`/process-charts/${processChartId}`);
}

export async function approveProcessChart(processChartId: number): Promise<ProcessChart> {
  const { data } = await apiClient.post<ProcessChart>(`/process-charts/${processChartId}/approve`);
  return data;
}

export async function revokeProcessChart(processChartId: number): Promise<ProcessChart> {
  const { data } = await apiClient.post<ProcessChart>(`/process-charts/${processChartId}/revoke`);
  return data;
}

export async function uploadProcessChartAttachments(
  processChartId: number,
  files: File[]
): Promise<ProcessChartAttachment[]> {
  const form = new FormData();
  files.forEach((file) => form.append('files', file));
  const { data } = await apiClient.post<ProcessChartAttachment[]>(
    `/process-charts/${processChartId}/attachments`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );
  return data;
}

export async function deleteProcessChartAttachment(
  processChartId: number,
  attachmentId: number
): Promise<void> {
  await apiClient.delete(`/process-charts/${processChartId}/attachments/${attachmentId}`);
}

export async function downloadProcessChartAttachment(
  processChartId: number,
  attachmentId: number,
  fileName: string
): Promise<void> {
  const { data } = await apiClient.get<Blob>(
    `/process-charts/${processChartId}/attachments/${attachmentId}/download`,
    { responseType: 'blob' }
  );
  const url = window.URL.createObjectURL(data);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  window.URL.revokeObjectURL(url);
}


export async function downloadProcessChartPdf(
  processChartId: number,
  fileName?: string
): Promise<void> {
  await downloadPdfBlob(
    `/process-charts/${processChartId}/pdf`,
    fileName || `공정도_${processChartId}.pdf`
  );
}
